// 共享类型定义

export interface ApiResponse<T = unknown> {
  success: boolean;
  data?: T;
  error?: string;
  message?: string;
}

export interface Item {
  id: number;
  title: string;
  description?: string;
  createdAt: string;
}

export interface CreateItemRequest {
  title: string;
  description?: string;
}

export interface UpdateItemRequest {
  title?: string;
  description?: string;
}

export interface Spark {
  id: number;
  user_id: number;
  name: string;
  prompt: string;
  html: string;
  is_public: boolean;
  likes: number;
  unlikes: number;
  created_at: string;
  creator_name?: string;
}

export interface CreateSparkRequest {
  name: string;
  prompt: string;
  html: string;
  is_public?: boolean;
}

export interface CreateSparkResponse {
  spark: Spark;
  remaining_points: number;
}

export type VoteType = "like" | "unlike";

export interface SparkReview {
  id: number;
  spark_id: number;
  user_id: number;
  comment: string | null;
  created_at: string;
  updated_at: string;
  reviewer_name?: string;
}

export interface UpsertReviewRequest {
  comment: string;
}

export interface VoteOnSparkRequest {
  vote: VoteType;
}

export const THEME_KEYS = [
  "bright",
  "sunset",
  "mint",
  "rose",
  "aurora",
  "midnight",
] as const;
export type ThemeKey = (typeof THEME_KEYS)[number];

